import React, {Component} from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {toast} from "react-toastify";
import {Swiper, SwiperSlide} from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import {addToCart} from "../../../redux/actions/Cart.Action";
import AddToCartModal from "../Cart/AddToCartModal";
import {safeLocalStorage} from "../../../Utils/storage";

class MostRecent extends Component {
  constructor(props) {
    super(props);
    let localRecentData = [];
    try {
      const stored = safeLocalStorage.getItem("MostRecent");
      if (stored) {
        localRecentData = JSON.parse(stored);
      }
      if (!stored) {
        safeLocalStorage.setItem("MostRecent", JSON.stringify([]));
      }
    } catch (e) {
      localRecentData = [];
      safeLocalStorage.setItem("MostRecent", JSON.stringify([]));
    }

    this.state = {
      show: false,
      product: "",
      note: "",
      place: 0,
      qty: 1,
      recentProduct: localRecentData,
    };
  }
  handleModalOpen($prd) {
    this.setState({ product: $prd });
    if (this.props.CurrentCart.length !== 0) {
      this.setState({ show: true, note: "", place: 0, qty: 1 });
    } else {
      toast.error("Please select the table", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        draggableDirection: "y",
      });
    }
  }
  handleModalClose = () => {
    this.setState({
      show: false,
    });
  };
  render() {
    return (
      <div className="card col-12">
        <div className="card-title p-2">
          <h6>Most Recent</h6>
        </div>
        <div className="card-body p-0">
          <Swiper
            slidesPerView={3}
            spaceBetween={10}
            breakpoints={{
              640: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 7,
                spaceBetween: 10,
              },
            }}
            className="mySwiper pt-2"
          >
            {this.state.recentProduct.length !== 0
              ? this.props.RecentView.map((prd, inx) => (
                  <SwiperSlide
                    className="category_slider bg-white"
                    onClick={() => this.handleModalOpen(prd)}
                    key={inx}
                  >
                    <div className="text-center align-items-start justify-content-between">
                      <LazyLoadImage
                        effect="blur"
                        className="avatar"
                        width={40}
                        height={40}
                        src={prd.image[0]}
                        alt={prd.name}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <span className="title">{prd.name}</span>
                    </div>
                  </SwiperSlide>
                ))
              : ""}
          </Swiper>
        </div>
        <AddToCartModal
          trigger={this.state.show}
          hideTrigger={this.handleModalClose}
          product={this.state.product}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    CurrentCart: state.Cart.CurrentCart,
    RecentView: state.Cart.RecentView,
  }),
  {
    addToCart,
  }
)(withRouter(React.memo(MostRecent)));
